import type { ParagraphFile } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import styles from "../Paragraph.module.css";

/**
 * Attachments — lista plików do pobrania pod akapitem.
 *
 * Backend (`IPARAGRAPH_CONTROLLER::getAttachments()`) zwraca pełen URL
 * download'a (przez `download(..., ['fullhost' => true])`), ext, size w MB
 * (3 miejsca po przecinku), opcjonalny opis.
 *
 * Zero-empty handling: gdy `files.length === 0` — komponent zwraca `null`
 * (nie renderuje pustej sekcji).
 */
export function Attachments({
  files,
  t,
}: {
  files: ParagraphFile[] | undefined;
  t: ParagraphTranslations;
}) {
  if (!files || files.length === 0) return null;

  return (
    <div className={styles.attachments}>
      <p className={styles.attachmentsHeading}>{t.attachments.heading}</p>
      <ul className={styles.attachmentsList}>
        {files.map((file) => (
          <li key={file.id}>
            <a
              href={file.url}
              className={styles.attachmentLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${t.attachments.download}: ${file.name}`}
              download
            >
              <span className={styles.attachmentExt}>{file.ext}</span>
              <span>{file.name}</span>
              {file.size && (
                <span className={styles.attachmentSize}>
                  ({t.attachments.sizeMb(file.size)})
                </span>
              )}
            </a>
            {file.description && (
              <div className={styles.attachmentSize}>{file.description}</div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
